"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'umi.block.sketch.select': 'Select',
  'umi.block.sketch.pencil': 'Pencil P',
  'umi.block.sketch.shape': 'Shape R',
  'umi.block.sketch.text': 'Text T',
  'umi.block.sketch.image': 'Image',
  'umi.block.sketch.undo': 'Undo',
  'umi.block.sketch.redo': 'Redo',
  'umi.block.sketch.clear': 'Clear',
  'umi.block.sketch.eraser': 'Eraser',
  'umi.block.sketch.save': 'Save',
  'umi.block.sketch.text.placeholder': 'Type something',
  'umi.block.sketch.text.size.small': 'Small',
  'umi.block.sketch.text.size.default': 'Default',
  'umi.block.sketch.text.size.large': 'Large'
};
exports.default = _default;